module.exports = __webpack_public_path__ + "img/resultExercise.45a4043d.png";